import { useSuspenseQuery } from "@tanstack/react-query";
import { formTranslationsQuery } from "src/system/formTranslationsQuery.ts";
import type { FormAction } from "src/components/Form/Form.types.ts";

export const useResourceFormTranslationsSuspenseQuery = ({
  resource,
  action,
  tab,
}: {
  resource: string;
  action: FormAction;
  tab?: string;
}) => {
  return useSuspenseQuery(
    formTranslationsQuery({
      resource,
      action,
      tab,
    }),
  );
};
